import React from "react";
import { Link } from "react-router-dom";
import { BrandMark } from "../../pages/AuthLayout";
import { BRAND } from "../../config/brand";
import { useT, LanguageToggle } from "./i18n";

export default function SiteFooter() {
  const { t } = useT();
  const L = t.footer.links;
  const cols = [
    [t.footer.cols.explore, [[L.professions, "#professions"], [L.community, "/community", true], [L.jobs, "#jobs"], [L.how, "#how"]]],
    [t.footer.cols.getstarted, [[L.joinTalent, "/register", true], [L.hireTalent, "/register", true], [L.signin, "/login", true]]],
    [t.footer.cols.legal, [[L.privacy, "/privacy", true], [L.terms, "/terms", true], [L.guidelines, "/guidelines", true], [L.contact, "#join"]]],
  ];

  return (
    <footer className="bg-[#12271E] py-14 text-white/80">
      <div className="mx-auto max-w-6xl px-5">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <BrandMark light />
            <p className="mt-4 max-w-xs text-sm text-white/60">{t.footer.tagline}</p>
          </div>
          {cols.map(([title, links]) => (
            <div key={title}>
              <h4 className="text-[11px] font-semibold uppercase tracking-[0.2em] text-[#C4A46B]">{title}</h4>
              <ul className="mt-4 space-y-2 text-sm">
                {links.map(([label, href, route]) => (
                  <li key={label}>
                    {route ? (
                      <Link to={href} className="text-white/70 transition-colors hover:text-white">{label}</Link>
                    ) : (
                      <a href={href} className="text-white/70 transition-colors hover:text-white">{label}</a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-6 text-xs text-white/50 sm:flex-row">
          <span>© {new Date().getFullYear()} {BRAND.name}. {t.footer.rights}</span>
          <div className="flex items-center gap-4">
            <span className="hidden sm:inline">{t.footer.note}</span>
            <LanguageToggle testid="footer-lang-toggle" />
          </div>
        </div>
      </div>
    </footer>
  );
}
